var c = (p, s, r) => new Promise((a, i) => {
  var l = (o) => {
    try {
      m(r.next(o));
    } catch (t) {
      i(t);
    }
  }, n = (o) => {
    try {
      m(r.throw(o));
    } catch (t) {
      i(t);
    }
  }, m = (o) => o.done ? a(o.value) : Promise.resolve(o.value).then(l, n);
  m((r = r.apply(p, s)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import C from "./aiPutCaseDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as _ } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as h, useTemplateRef as y, withDirectives as v, openBlock as P, createBlock as g, withCtx as u, createVNode as d } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as N } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import D from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const M = /* @__PURE__ */ h({
  __name: "index.ce",
  setup(p, { expose: s }) {
    const r = y("aiPutCaseDialogRefs");
    let a = null;
    const i = N(), l = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, n = (o) => c(this, null, function* () {
      var t;
      return (t = r.value) == null || t.open({
        orderId: o.orderId || "",
        productionOrderContractNo: o.productionOrderContractNo || ""
      }), new Promise((f) => {
        a = f;
      });
    }), m = (o) => {
      a && (a(o), a = null);
    };
    return s({ open: n }), (o, t) => v((P(), g(e(x), {
      locale: e(w),
      "date-locale": e(R),
      "theme-overrides": l,
      "style-mount-target": e(i)
    }, {
      default: u(() => [
        d(e(D), { to: e(i) }, {
          default: u(() => [
            d(C, {
              ref_key: "aiPutCaseDialogRefs",
              ref: r,
              onSubmit: m
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [e(_), e(i)]
    ]);
  }
});
export {
  M as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-put_case-dialog/index.ce.vue2.js
// module id = 1162
// module chunks = 41